import { render, staticRenderFns } from "./stub.vue?vue&type=template&id=2242c181&scoped=true&"
import script from "./stub.vue?vue&type=script&lang=js&"
export * from "./stub.vue?vue&type=script&lang=js&"
import style0 from "./stub.vue?vue&type=style&index=0&id=2242c181&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242c181",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2242c181')) {
      api.createRecord('2242c181', component.options)
    } else {
      api.reload('2242c181', component.options)
    }
    module.hot.accept("./stub.vue?vue&type=template&id=2242c181&scoped=true&", function () {
      api.rerender('2242c181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/stubs/stub.vue"
export default component.exports